/* global system */

import verifyToken from '@/utils/verifyToken'
import localStorage from '../utils/localStorage'
import API from '../api'

import { get } from '../utils/index'

export default {
  login({
    callback = null
  } = {}) {
    console.log('login')
    return new Promise((resolve, reject) => {
      system.onmessage = function(data) {
        console.log('system.onmessage: ', data)
        // 取消对于的onmessage的监听
        system.onmessage = null

        data = data ? JSON.parse(data) : {};

        if ( data && parseInt( data.id ) === 1 ) {
          const userInfo = data.result ? data.result.userInfo : {};

          let {
            authcode,
            refreshcode = ""
          } = userInfo;

          localStorage.set('authcode', authcode)
          localStorage.set('refreshcode', refreshcode)

          console.log('callback1', callback)

          // if(callback) callback();

          resolve({
            authcode,
            refreshcode,
            isCallBackFirst: callback ? true : false
          })

        } else {
          reject({
            platform: 'quickapp',
            name: data.name || 'QuickAppLoginFailed',
            message: data.message || '登录失败'
          })
        }
      }

      system.postMessage( '{"jsonrpc": "2.0", "id":1, "method": "Common.login", "params":{}}' );
    })
  },

  logout() {
    console.log('logout')
    return new Promise(resolve => {
      system.postMessage('logout')
      resolve()
    })
  },

  getToken() {
    return verifyToken().then(({ authcode }) => {
      return Promise.resolve({ authcode })
    }).catch((error) => {
      return Promise.reject(error)
    })
  },

  refreshToken() {
    let refreshcode = localStorage.get('refreshcode')
    if (refreshcode) {
      return API.login['41012'](refreshcode).then(r => {
        // console.log('refreshToken r: ', r)
        let code = get(r, 'res.hd.code')
        if (code === 1) {
          let bd = get(r, 'res.bd')
          localStorage.set('authcode', bd.authcode)
          localStorage.set('authExpiretime', bd.authExpiretime)

          return {
            authcode: bd.authcode
          }
        }
      });
    } else {
      return Promise.reject(null)
    }
  }
};



// WEBPACK FOOTER //
// ./src/auth/hbQuickApp.js